export const saveSearchListStyle = {

  '.listBlock': {
    color: '#333333 !important',
    paddingLeft: '10px !important',
    background: 'white',
    border: 'solid 1px',
    borderRadius: '6px',
    borderColor: 'lightgrey',
    padding: '0.5rem',
    margin: '0px 18px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '.header': {
    display: 'flex',
    flexDirection: 'row',
    padding: '15px 15px 5px 15px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  '.navigation': {
    width: '350px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: '99',
    background: '#fff',
    listStyle: 'none',
    paddingLeft: '0',
  },
  listItem: {
    paddingLeft: '5px !important',
  },
  '.navigationItemList': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0px 15px',
  },
  '.listBlockItem': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '40px',
  },
  '.saveSection': {
    marginBottom: '8px',
    marginTop: '8px',
  },
  '.timezone': {
    top: '100%',
    left: ' 0',
    right: '0',
    maxHeight: '200px',
    overflowY: 'auto',
    margin: ' 0',
    padding: '0',
    border: '1px solid #e6ebec',
    marginTop: '-1px',
    borderRadius: '0 0 3px 3px',
  },
  '.saveButton': {
    width: '20px',
    margin: '20px auto',
  },
  '.saveButtonTheme': {
    padding: '10px !important',
    textAlign: 'center !important',
  },
  '.menu': {
    boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)',
    marginTop: 8,
    position: 'absolute',
    zIndex: 100,
    color: '#000 !important',
    paddingLeft: '10px !important',
    background: 'white',
    border: 'solid 1px #ecedee',
    borderRadius: '6px',
    padding: '0.5rem',
    width: '98%',
    margin: '0px 15px',
    maxHeight: '350px',
    overflowY: 'auto',
  },
};

export const searchSelectStyle = (provided) => ({
  ...provided,
  minWidth: 240,
  margin: 8,
  backgroundColor: ' #f7f8f9',
  border: '0.0625rem solid #8e9092',
  borderRadius: '0.25rem',
  color: '#000',
  marginTop: '5px',
  marginBottom: '0px',
  fontSize: '1rem',
  lineHeight: '1.375rem',
  minHeight: '3.125rem',
  padding: '0 0.625rem',
  borderColor: '0.25S ease-out',
  width: '100%',
  cursor: 'pointer',
});
